import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../app';
import FormModal from './FormModal';
import KeyboardNavigatable from '../utils/KeyboardNavigatable';
import SearchManager from '../SearchManager';
import extractText from '../utils/extractText';
import Input from './Input';
import Button from './Button';
import Stream from '../utils/Stream';
import InfoTile from './InfoTile';
import LoadingIndicator from './LoadingIndicator';
import ItemList from '../utils/ItemList';
import GambitsAutocomplete from '../utils/GambitsAutocomplete';
export default class SearchModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "searchState", void 0);
    _defineProperty(this, "query", void 0);
    /**
     * An array of SearchSources.
     */
    _defineProperty(this, "sources", void 0);
    /**
     * The key of the currently-active search source.
     */
    _defineProperty(this, "activeSource", void 0);
    /**
     * The sources that are still loading results.
     */
    _defineProperty(this, "loadingSources", []);
    /**
     * The index of the currently-selected <li> in the results list. This can be
     * a unique string (to account for the fact that an item's position may jump
     * around as new results load), but otherwise it will be numeric (the
     * sequential position within the list).
     */
    _defineProperty(this, "index", 0);
    _defineProperty(this, "navigator", void 0);
    _defineProperty(this, "searchTimeout", void 0);
    _defineProperty(this, "inputScroll", Stream(0));
    _defineProperty(this, "gambitsAutocomplete", {});
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.searchState = this.attrs.searchState;
    this.sources = this.attrs.sources;
    this.activeSource = Stream(this.defaultActiveSource() ? this.sources.find(source => source.resource === this.defaultActiveSource()) || this.sources[0] : this.sources[0]);
    this.query = Stream(this.prefill(this.searchState.getValue() || '').trim());
  }
  title() {
    return app.translator.trans('core.lib.search.title');
  }
  className() {
    return 'SearchModal Modal--flat';
  }
  content() {
    var _this$gambitsAutocomp, _this$activeSource$re;
    (_this$gambitsAutocomp = this.gambitsAutocomplete)[_this$activeSource$re = this.activeSource().resource] || (_this$gambitsAutocomp[_this$activeSource$re] = new GambitsAutocomplete(this.activeSource().resource, () => this.inputElement(), this.query, value => this.search(value)));
    const searchLabel = extractText(app.translator.trans('core.lib.search.placeholder'));
    return m("div", {
      className: "Modal-body SearchModal-body"
    }, m("div", {
      className: "SearchModal-form"
    }, m(Input, {
      key: "search",
      type: "search",
      loading: !!this.loadingSources.length,
      clearable: true,
      clearLabel: app.translator.trans('core.lib.search.search_clear_button_accessible_label'),
      prefixIcon: "fas fa-search",
      "aria-label": searchLabel,
      placeholder: searchLabel,
      value: this.query(),
      onchange: value => {
        var _this$inputElement$0$, _this$inputElement$;
        this.query(value);
        this.inputScroll((_this$inputElement$0$ = (_this$inputElement$ = this.inputElement()[0]) == null ? void 0 : _this$inputElement$.scrollLeft) != null ? _this$inputElement$0$ : 0);
      },
      inputAttrs: {
        className: 'SearchModal-input'
      },
      renderInput: attrs => m('[', null, m("input", Object.assign({}, attrs, {
        onscroll: e => this.inputScroll(e.target.scrollLeft)
      })), m("div", {
        className: "SearchModal-visual-wrapper"
      }, m("div", {
        className: "SearchModal-visual-input",
        style: {
          left: '-' + this.inputScroll() + 'px'
        }
      }, this.gambifyInput())))
    })), this.tabs());
  }
  tabs() {
    return m("div", {
      className: "Tabs"
    }, m("div", {
      className: "Tabs-nav"
    }, this.tabItems().toArray()), m("div", {
      className: "Tabs-content SearchModal-tabs-content"
    }, this.activeTabItems().toArray()));
  }
  tabItems() {
    var _this$sources;
    const items = new ItemList();
    (_this$sources = this.sources) == null || _this$sources.map((source, index) => items.add(source.resource, m(Button, {
      className: "Button Button--link",
      active: this.activeSource() === source,
      onclick: () => this.switchSource(source)
    }, source.title()), 100 - index));
    return items;
  }
  activeTabItems() {
    var _this$activeSource;
    const items = new ItemList();
    const loading = this.loadingSources.includes(this.activeSource().resource);
    const shouldShowResults = !!this.query() && !loading;
    const gambits = this.gambits();
    const fullPageLink = this.activeSource().fullPage(this.query());
    const results = (_this$activeSource = this.activeSource()) == null ? void 0 : _this$activeSource.view(this.query());
    const customGrouping = this.activeSource().customGrouping();
    if (shouldShowResults && fullPageLink) {
      items.add('fullPageLink', m("div", {
        className: "SearchModal-section"
      }, m("hr", {
        className: "Modal-divider"
      }), m("ul", {
        className: "Dropdown-menu SearchModal-fullPage"
      }, fullPageLink)), 80);
    }
    if (!!gambits.length) {
      items.add('gambits', m("div", {
        className: "SearchModal-section"
      }, m("hr", {
        className: "Modal-divider"
      }), m("ul", {
        className: "Dropdown-menu SearchModal-options",
        "aria-live": gambits.length ? 'polite' : undefined
      }, m("li", {
        className: "Dropdown-header"
      }, app.translator.trans('core.lib.search.options_heading')), gambits)), 60);
    }
    items.add('results', m("div", {
      className: "SearchModal-section"
    }, m("hr", {
      className: "Modal-divider"
    }), m("ul", {
      className: "Dropdown-menu SearchModal-results",
      "aria-live": shouldShowResults ? 'polite' : undefined
    }, !customGrouping && m("li", {
      className: "Dropdown-header"
    }, app.translator.trans('core.lib.search.preview_heading')), !shouldShowResults && m("li", {
      className: "Dropdown-message"
    }, m(InfoTile, {
      icon: "fas fa-search"
    }, app.translator.trans('core.lib.search.no_search_text'))), shouldShowResults && results, shouldShowResults && !(results != null && results.length) && m("li", {
      className: "Dropdown-message"
    }, m(InfoTile, {
      icon: "far fa-tired"
    }, app.translator.trans('core.lib.search.no_results_text'))), loading && m("li", {
      className: "Dropdown-message"
    }, m(LoadingIndicator, null)))), 40);
    return items;
  }
  switchSource(source) {
    if (this.activeSource() !== source) {
      this.activeSource(source);
      this.search(this.query());
      this.inputElement().focus();
      m.redraw();
    }
  }
  gambits() {
    return this.gambitsAutocomplete[this.activeSource().resource].suggestions(this.query());
  }

  /**
   * Transforms a simple search text to wrap valid gambits in a mark tag.
   * @example `lorem ipsum is:unread dolor` => `lorem ipsum <mark>is:unread</mark> dolor`
   */
  gambifyInput() {
    const query = this.query();
    let marked = query;
    app.search.gambits.match(this.activeSource().resource, query, (gambit, matches, negate, bit) => {
      marked = marked.replace(bit, "<mark>".concat(bit, "</mark>"));
    });
    const jsx = [];
    marked.split(/(<mark>.*?<\/mark>)/).forEach(chunk => {
      if (chunk.startsWith('<mark>')) {
        jsx.push(m("mark", null, chunk.replace(/<\/?mark>/g, '')));
      } else {
        jsx.push(chunk);
      }
    });
    return jsx;
  }
  onupdate(vnode) {
    var _this$sources2;
    super.onupdate(vnode);

    // Highlight the item that is currently selected.
    this.setIndex(this.getCurrentNumericIndex());
    const component = this;
    this.$('.Dropdown-menu')
    // Whenever the mouse is hovered over a search result, highlight it.
    .on('mouseenter', '> li:not(.Dropdown-header):not(.Dropdown-message)', function () {
      component.setIndex(component.selectableItems().index(this));
    });

    // If there are no sources, the search view is not shown.
    if (!((_this$sources2 = this.sources) != null && _this$sources2.length)) return;
  }
  oncreate(vnode) {
    var _this$sources3;
    super.oncreate(vnode);

    // If there are no sources, we shouldn't initialize logic for
    // search elements, as they will not be shown.
    if (!((_this$sources3 = this.sources) != null && _this$sources3.length)) return;
    const search = this.search.bind(this);

    // Highlight the item that is currently selected.
    this.setIndex(this.getCurrentNumericIndex());
    const $input = this.inputElement();
    this.navigator = new KeyboardNavigatable();
    this.navigator.onUp(() => this.setIndex(this.getCurrentNumericIndex() - 1, true)).onDown(() => this.setIndex(this.getCurrentNumericIndex() + 1, true)).onSelect(this.selectResult.bind(this), true).onCancel(this.clear.bind(this)).bindTo($input);

    // Handle input key events on the search input, triggering results to load.
    $input.on('input focus', function () {
      search(this.value.toLowerCase());
    });
  }
  onremove(vnode) {
    this.searchState.setValue(this.query());
    super.onremove(vnode);
  }
  search(query) {
    if (!query) return;
    const source = this.activeSource();
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = window.setTimeout(() => {
      if (source.isCached(query)) return;
      if (query.length >= SearchManager.MIN_SEARCH_LEN) {
        if (!source.search) return;
        this.loadingSources.push(source.resource);
        source.search(query, SearchModal.LIMIT).then(() => {
          this.loadingSources = this.loadingSources.filter(resource => resource !== source.resource);
          m.redraw();
        });
      }
      this.searchState.cache(query);
      m.redraw();
    }, SearchManager.SEARCH_DEBOUNCE_TIME_MS);
  }

  /**
   * Navigate to the currently selected search result and close the list.
   */
  selectResult() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.loadingSources = [];
    const item = this.getItem(this.index);
    const isResult = !!item.attr('data-id');
    let selectedUrl = null;
    if (isResult) {
      const id = item.attr('data-id');
      selectedUrl = id && this.activeSource().gotoItem(id);
    }

    // Fallback: if gotoItem returned null or item has no data-id, check for a link
    if (!selectedUrl && item.find('a').length) {
      selectedUrl = item.find('a').attr('href') || null;
    }
    const query = this.query();
    if (query && selectedUrl) {
      m.route.set(selectedUrl);
    } else if (item.find('button').length) {
      item.find('button')[0].click();
    }
  }

  /**
   * Clear the search
   */
  clear() {
    this.query('');
  }

  /**
   * Get all of the search result items that are selectable.
   */
  selectableItems() {
    return this.$('.Dropdown-menu > li:not(.Dropdown-header):not(.Dropdown-message)');
  }

  /**
   * Get the position of the currently selected search result item.
   * Returns zero if not found.
   */
  getCurrentNumericIndex() {
    return Math.max(0, this.selectableItems().index(this.getItem(this.index)));
  }

  /**
   * Get the <li> in the search results with the given index (numeric or named).
   */
  getItem(index) {
    const $items = this.selectableItems();
    let $item = $items.filter("[data-index=\"".concat(index, "\"]"));
    if (!$item.length) {
      $item = $items.eq(index);
    }
    return $item;
  }

  /**
   * Set the currently-selected search result item to the one with the given
   * index.
   */
  setIndex(index, scrollToItem) {
    if (scrollToItem === void 0) {
      scrollToItem = false;
    }
    const $items = this.selectableItems();
    const $dropdown = $items.parent();
    let fixedIndex = index;
    if (index < 0) {
      fixedIndex = $items.length - 1;
    } else if (index >= $items.length) {
      fixedIndex = 0;
    }
    const $item = $items.removeClass('active').eq(fixedIndex).addClass('active');
    this.index = parseInt($item.attr('data-index')) || fixedIndex;
    if (scrollToItem && $dropdown) {
      const dropdownScroll = $dropdown.scrollTop();
      const dropdownTop = $dropdown.offset().top;
      const dropdownBottom = dropdownTop + $dropdown.outerHeight();
      const itemTop = $item.offset().top;
      const itemBottom = itemTop + $item.outerHeight();
      let scrollTop;
      if (itemTop < dropdownTop) {
        scrollTop = dropdownScroll - dropdownTop + itemTop - parseInt($dropdown.css('padding-top'), 10);
      } else if (itemBottom > dropdownBottom) {
        scrollTop = dropdownScroll - dropdownBottom + itemBottom + parseInt($dropdown.css('padding-bottom'), 10);
      }
      if (typeof scrollTop !== 'undefined') {
        $dropdown.stop(true).animate({
          scrollTop
        }, 100);
      }
    }
  }
  inputElement() {
    return this.$('.SearchModal-input');
  }
  defaultActiveSource() {
    const inDiscussion = app.current.data.routeName && ['discussion', 'discussion.near'].includes(app.current.data.routeName) && app.current.data.discussion;
    const inUser = app.current.data.routeName && app.current.data.routeName.includes('user.posts') && app.current.data.user;
    const inPosts = app.current.data.routeName && app.current.data.routeName === 'posts';
    if (inDiscussion || inUser || inPosts) {
      return 'posts';
    }
    return null;
  }
  defaultFilters() {
    const filters = {};
    this.sources.forEach(source => {
      filters[source.resource] = {};
    });
    if (app.current.data.routeName && ['discussion', 'discussion.near'].includes(app.current.data.routeName) && app.current.data.discussion) {
      filters.posts.discussion = app.current.data.discussion.id();
    }
    if (app.current.data.routeName && app.current.data.routeName.includes('user.posts') && app.current.data.user) {
      filters.posts.author = app.current.data.user.username();
    }
    return filters;
  }
  prefill(value) {
    const newQuery = app.search.gambits.from(this.activeSource().resource, value, this.defaultFilters()[this.activeSource().resource] || {});
    if (!value.includes(newQuery.replace(value, '').trim())) {
      return newQuery;
    }
    return value;
  }
}
_defineProperty(SearchModal, "LIMIT", 6);
flarum.reg.add('core', 'common/components/SearchModal', SearchModal);